export class BucketPathPartitionSpec {
    'separator';
    'segments';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "separator",
            "baseName": "separator",
            "type": "string",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "Array<PathSegment>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketPathPartitionSpec.attributeTypeMap;
    }
    constructor() {
    }
}
